(() => {
  const initialize = () => document.querySelectorAll('[data-pdl-home-vehicle-tool]').forEach(root => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const load = () => window.pdlVehicleCompatibility.mountQuickSearch(root);
    if (!('IntersectionObserver' in window)) { load(); return; }
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      observer.disconnect(); load();
    }, { rootMargin: '100px' });
    observer.observe(root);
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
